import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** calendar with schedule lines. Decorative line icon; always pair with a visible text label. */
export function PlannerIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <rect x="3.5" y="5" width="17" height="16" rx="3" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M3.5 10h17" />
      <path d="M7.5 14h4" />
      <path d="M7.5 17h7" />
    </IconSvg>
  )
}
